import { render } from "./FlashcardsPage.vue?vue&type=template&id=bbaf4118&scoped=true"
import script from "./FlashcardsPage.vue?vue&type=script&lang=js"
export * from "./FlashcardsPage.vue?vue&type=script&lang=js"

import "./FlashcardsPage.vue?vue&type=style&index=0&id=bbaf4118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaf4118"]])

export default __exports__